"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RIBBON_BUTTON_FONT_NAME = 'fontname';
exports.RIBBON_BUTTON_FONT_SIZE = 'fontsize';
exports.RIBBON_BUTTON_BOLD = 'bold';
exports.RIBBON_BUTTON_ITALIC = 'italic';
exports.RIBBON_BUTTON_UNDERLINE = 'underline';
exports.RIBBON_BUTTON_BACK_COLOR = 'backcolor';
exports.RIBBON_BUTTON_TEXT_COLOR = 'textcolor';
exports.RIBBON_BUTTON_BULLETS = 'bullets';
exports.RIBBON_BUTTON_NUMBERING = 'numbering';
exports.RIBBON_BUTTON_INDENT = 'indent';
exports.RIBBON_BUTTON_OUTDENT = 'outdent';
exports.RIBBON_BUTTON_ALIGN_LEFT = 'alignleft';
exports.RIBBON_BUTTON_ALIGN_CENTER = 'aligncenter';
exports.RIBBON_BUTTON_ALIGN_RIGHT = 'alignright';
exports.RIBBON_BUTTON_CREATE_LINK = 'createlink';
exports.RIBBON_BUTTON_UNLINK = 'unlink';
exports.RIBBON_BUTTON_SUBSCRIPT = 'subscript';
exports.RIBBON_BUTTON_SUPERSCRIPT = 'superscript';
exports.RIBBON_BUTTON_STRIKETHROUGH = 'strikethrough';
exports.RIBBON_BUTTON_ADDIMAGEALTTEXT = 'alttext';
exports.RIBBON_BUTTON_LEFTTORIGHT = 'ltr';
exports.RIBBON_BUTTON_RIGHTTOLEFT = 'rtl';
exports.RIBBON_BUTTON_UNDO = 'undo';
exports.RIBBON_BUTTON_REDO = 'redo';
exports.RIBBON_BUTTON_REMOVE_FORMAT = 'removeformat';
exports.RIBBON_BUTTON_AFFORDANCE = 'more';
exports.RIBBON_BUTTON_FORMATPAINTER = 'formatPainter';
exports.RIBBON_BUTTON_BLOCKQUOTE = 'blockquote';
/**
 * Complete ribbon button list. This is also the order of buttons as they appear in ribbon and should be maintained as it is.
 * NOTE: this does not include affordance which is handled separately
 */
exports.RIBBON_BUTTON_LIST = [
    exports.RIBBON_BUTTON_FORMATPAINTER,
    exports.RIBBON_BUTTON_FONT_NAME,
    exports.RIBBON_BUTTON_FONT_SIZE,
    exports.RIBBON_BUTTON_BOLD,
    exports.RIBBON_BUTTON_ITALIC,
    exports.RIBBON_BUTTON_UNDERLINE,
    exports.RIBBON_BUTTON_BACK_COLOR,
    exports.RIBBON_BUTTON_TEXT_COLOR,
    exports.RIBBON_BUTTON_BULLETS,
    exports.RIBBON_BUTTON_NUMBERING,
    exports.RIBBON_BUTTON_OUTDENT,
    exports.RIBBON_BUTTON_INDENT,
    exports.RIBBON_BUTTON_BLOCKQUOTE,
    exports.RIBBON_BUTTON_ALIGN_LEFT,
    exports.RIBBON_BUTTON_ALIGN_CENTER,
    exports.RIBBON_BUTTON_ALIGN_RIGHT,
    exports.RIBBON_BUTTON_CREATE_LINK,
    exports.RIBBON_BUTTON_UNLINK,
    exports.RIBBON_BUTTON_SUPERSCRIPT,
    exports.RIBBON_BUTTON_SUBSCRIPT,
    exports.RIBBON_BUTTON_STRIKETHROUGH,
    exports.RIBBON_BUTTON_ADDIMAGEALTTEXT,
    exports.RIBBON_BUTTON_LEFTTORIGHT,
    exports.RIBBON_BUTTON_RIGHTTOLEFT,
    exports.RIBBON_BUTTON_UNDO,
    exports.RIBBON_BUTTON_REDO,
    exports.RIBBON_BUTTON_REMOVE_FORMAT,
];
//# sourceMappingURL=ButtonNames.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor-ribbonplugin/lib/store/schema/ButtonNames.js
// module id = 2165
// module chunks = 2 3 59 108